import axiosServices from 'utils/axios';

export interface UserCompanyContext {
  companyId: number;
  companyName: string;
  canSelectAllSites: boolean;
  sites: Array<{ siteId: number; siteName: string; companyId: number }>;
}

export interface UserContextAccess {
  canSelectAllCompanies: boolean;
  companies: UserCompanyContext[];
}

export async function getUserContextAccess(tenantId: number): Promise<UserContextAccess> {
  const response = await axiosServices.get<UserContextAccess>('api/users/me/context', {
    headers: { 'X-Tenant-Id': String(tenantId), 'X-Company-Id': false, 'X-Site-Id': false }
  });
  return response.data;
}
